// extracted by mini-css-extract-plugin
module.exports = {"formGroup":"style_formGroup___JJbg","mandatory":"style_mandatory__NHEGK"};